const dotloader = {
  '0%': {
    opacity: 0
  },
  '50%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
};
export default dotloader;